'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

interface UseUserInfoProps {
  enabled?: boolean;
}

/**
 * 현재 인증된 큐레이터 사용자 정보를 조회하는 훅(현재는 29cm만 반환함)
 * @returns 사용자 정보 쿼리 결과 (platform, userId)
 */
export function useUserInfo(
  { enabled }: UseUserInfoProps = {
    enabled: true,
  },
) {
  return useQuery({
    ...curatorQueries.profile.userInfo,
    enabled,
    meta: {
      skipGlobalErrorHandler: true,
    },
  });
}
